import React from 'react';
import { useTranslation } from 'react-i18next';
import { Info } from 'lucide-react';

/**
 * FoundersPricingNote — Iter 124 (Feb 2026)
 *
 * Subtle, reassuring one-line clarification shown on the business dashboard
 * for founders-plan businesses. Reminds them that listing/events/offers are
 * free during the launch period and that boosts are optional and only add
 * visibility. Deliberately quiet — info icon, soft slate background, no CTA.
 *
 * Hidden for paid plans (basic / 12months / 6months) because the framing
 * doesn't apply to them.
 */
const FoundersPricingNote = ({ subscriptionPlan }) => {
  const { t } = useTranslation();
  if (subscriptionPlan !== 'founders') return null;

  return (
    <div
      className="bg-slate-50 border border-slate-200 rounded-xl px-4 py-3 flex items-start gap-3"
      data-testid="founders-pricing-note"
    >
      <Info className="h-4 w-4 text-slate-500 flex-shrink-0 mt-0.5" aria-hidden="true" />
      <p className="text-xs sm:text-sm text-slate-700 leading-relaxed">
        {t(
          'foundersPricingNote',
          'Your business listing, events and offers are included free during the Founding Business launch period. Optional boosts are available if you want extra visibility across the Almería region.'
        )}
      </p>
    </div>
  );
};

export default FoundersPricingNote;
